import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=8cf0ef16&scoped=true"
var script = {}
import style0 from "./Logout.vue?vue&type=style&index=0&id=8cf0ef16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf0ef16",
  null
  
)

export default component.exports